import * as React from "react";
import { cn } from "@/app/utils/tw-merge";

/** Native <select> styled — UI admin không cần dropdown phức tạp. */
export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    data-slot="select"
    className={cn(
      "flex h-9 w-full rounded-md border border-foreground/20 bg-input-background px-3 py-1 text-sm shadow-sm focus-visible:border-primary focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive",
      className
    )}
    {...props}
  >
    {children}
  </select>
));
Select.displayName = "Select";
